import posthog from "posthog-js";

/** How React met the error: caught by an error boundary, not caught at all, or recovered from. */
export type ReactErrorKind = "caught" | "uncaught" | "recoverable";

/**
 * The single reporting path for errors React sees. It is wired into `createRoot`, so an error
 * caught by any error boundary (the router's included) or escaping all of them is reported once,
 * here; boundaries must not report on their own. Replacing React's default root handlers also
 * replaces their console output, so this logs as well. Errors outside rendering (event handlers,
 * rejected promises) are captured by PostHog's window hooks instead.
 *
 * `posthog.captureException` is a no-op until PostHog is initialised.
 */
export function reportReactError(
  kind: ReactErrorKind,
  error: unknown,
  errorInfo: { componentStack?: string },
): void {
  console.error(`[react] ${kind} error`, error, errorInfo.componentStack ?? "");
  posthog.captureException(error, {
    react_error_kind: kind,
    ...(errorInfo.componentStack ? { component_stack: errorInfo.componentStack } : {}),
  });
}
